import { useTileFilters } from '@/catalog-apps/hooks/useTileFilters'
import { ChartLoading } from '../ChartComponent'
import { TileFilter } from '../shared/TileFilter'
import { useGetChartWaterfall } from './useGetChartWaterfall'
import { ChartWaterfallContent } from './ChartWaterfallContent'

export const ChartWaterfallComponent = ({ id }: { id: string }) => {
  const { tileFilterSelections } = useTileFilters()
  const { data, refetch } = useGetChartWaterfall(id, tileFilterSelections)

  return (
    <ChartWaterfallContent
      reloadHandler={refetch}
      tileFilters={<TileFilter schema={data.filters} />}
      uiSchema={data.uiSchema}
      dataSchema={data.dataSchema}
    />
  )
}

export function ChartWaterfallComponentLoading() {
  return <ChartLoading />
}
